import OrchestratorAPI from './common.js';
import {
  type EhrInstanceField,
  type EhrInstanceFieldWithTypeAndName,
} from '../models/orchestrator/ehrInstanceField.js';
import { type SetValues } from '../models/orchestrator/instanceField.js';

type FindForEhrInstanceSearch =
  | {
      canonicalFieldId: string;
    }
  | {
      canonicalFieldTypeName: string;
      canonicalFieldValue?: string;
    }
  | {
      canonicalFieldTypeName: string;
      apiInstanceFieldValue?: string;
    };

export default class API extends OrchestratorAPI {
  protected readonly API_PATH = '/ehr-instance-fields';

  async findForEhrInstance(
    ehrInstanceId: string,
    searchQuery: FindForEhrInstanceSearch
  ): Promise<EhrInstanceFieldWithTypeAndName[]> {
    const url = this.constructPath(`/ehr-instances/${ehrInstanceId}`, searchQuery);
    const { ehrInstanceFields } = await this.common.getJSON(url);
    return ehrInstanceFields.map(this.deserialize);
  }

  async setForEhrInstance(args: {
    ehrInstanceId: string;
    canonicalFieldTypeId: string;
    values: SetValues[];
  }): Promise<EhrInstanceField[]> {
    const { ehrInstanceId, canonicalFieldTypeId, values } = args;

    const url = this.constructPath(
      `/ehr-instances/${ehrInstanceId}/canonical-field-types/${canonicalFieldTypeId}`
    );
    const { ehrInstanceFields } = await this.common.postJSON(url, values);
    return ehrInstanceFields.map(this.deserialize);
  }
}
